// src/components/ClickableText.jsx
import React from 'react';

const ClickableText = ({ text, onClick }) => (
  <p
    onClick={onClick}
    className="text-center text-sm mt-4 text-black cursor-pointer hover:underline"
  >
    {text}
  </p>
);

export default ClickableText;
